export const questions = [
  {
    question:
      "Does your organization have written policies and procedures in place to combat money laundering and terrorist financing?",
  },
  {
    question:
      "Does your organisation have a designated Anti-Money Laundering (AML) Officer and/or Compliance Officer?",
  },
  {
    question:
      "Does your organisation have a policy prohibiting accounts/relationships with shell Entities?",
  },
  {
    question:
      "Has your organization or any of its personnel been investigated for actual/suspected involvement in money laundering and/or terrorism?",
  },
  {
    question:
      "Does your organization currently have a Politically Exposed Person(s) as an executive, board member or Senior Management",
  },
  {
    question:
      "Has your organization or any of its personnel been listed as being involved in money laundering or terrorist activities? ",
  },
  {
    question:
      "Has your organization or its personnel been subject to allegations, investigation ,prosecution or convicted of any law relating to any financial/economic crime or Terrorism/Terrorist financing?",
  },
  {
    question:
      "Has your organization within the last three years been subject to litigation or any disciplinary action by a court, professional body or regulatory agency?",
  },
  {
    question:
      "Do you perform adequate due diligence for corruption, money laundering, and terrorist financing matters on your organization`s contractors, subcontractors, dealers or sub-dealers?",
  },
  {
    question:
      "Does your institution have an established employee-training program to teach employees about money laundering and terrorist financing and assist them to identify suspicious activities? ",
  },
  {
    question:
      "Does your institution have internal audit and compliance to review your prevention of corruption, AML and anti-terrorist financing procedures and policies?",
  },
  {
    question:
      "Does your institution have a risk-based assessment of its customer base and their transactions?",
  },
  {
    question: "Does your company have branches?",
  },
  {
    question:
      "What documents/KYC information details do you require from your customers?",
  },
  {
    question: "For how long do you keep your customer information?",
  },
  {
    question: "Describe how you report suspicious activities.",
  },
];
